import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {plainToInstance} from "class-transformer";
import {MesApiService} from "common-shared";
import {ConfigurationModel} from "./configuration.model";

@Injectable({
  providedIn: 'root'
})
export class ConfigurationDataService  extends MesApiService {

  constructor() {
    super('Configuration', 'manufacturing');
  }

  get(id: string): Observable<ConfigurationModel> {
    return this.getSingle<ConfigurationModel>({id: id, action: 'GetModel'}).pipe(map(value => {
      return plainToInstance(ConfigurationModel, value.data);
    }));
  }

  save(salesOrder: ConfigurationModel) {
    return this.update<ConfigurationModel>(salesOrder.Id, salesOrder, {
      action: 'SaveModel'
    }).pipe(map(value => {
      return plainToInstance(ConfigurationModel, value.data);
    }));
  }

  remove(configuration: ConfigurationModel) {
    return this.delete<ConfigurationModel>(configuration.Id).pipe(map(value => {
      return plainToInstance(ConfigurationModel, value.data);
    }));
  }
}
